import console from "./console";

// POC test to use window.crypto for local storage en-, decryption
const USE_CRYPRO = true;

function convertStringToArrayBuffer(str) {
  const encoder = new TextEncoder();
  return encoder.encode(str);
}

function convertArrayBuffertoString(buffer) {
  const decoder = new TextDecoder();
  return decoder.decode(buffer);
}

const toBase64 = buffer =>
  btoa(String.fromCharCode(...new Uint8Array(buffer)));

const fromBase64 = buffer =>
  Uint8Array.from(atob(buffer), c => c.charCodeAt(0));

export const hasCrypto = () => {
  return USE_CRYPRO && window.crypto && window.crypto.subtle;
};

const PBKDF2 = async (tkey, salt, iterations = 100000, length = 256, hash = 'SHA-256', algorithm = 'AES-CBC') => {
  const keyMaterial = await window.crypto.subtle.importKey(
    'raw',
    convertStringToArrayBuffer(tkey),
    { name: 'PBKDF2' },
    false,
    ['deriveKey']
  );
  return window.crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt: convertStringToArrayBuffer(salt),
      iterations,
      hash
    },
    keyMaterial,
    { name: algorithm, length },
    false, // we don't need to export our key!!!
    ['encrypt', 'decrypt']
  )
    .catch(e => {
      console.debug("Error while importing key: " + e.message);
      throw e;
    });
};

const salt_len = 16;
const iv_len = 16;

export const encode = async (text, tkey) => {
  const salt = window.crypto.getRandomValues(new Uint8Array(salt_len));
  const iv = window.crypto.getRandomValues(new Uint8Array(iv_len));
  const plain_text = convertStringToArrayBuffer(text);
  const key = await PBKDF2(tkey, salt);

  const encrypted = await window.crypto.subtle.encrypt(
    { name: "AES-CBC", iv },
    key,
    plain_text
  );

  const concatennated = toBase64([
    ...salt,
    ...iv,
    ...new Uint8Array(encrypted)
  ]);
  console.log({
    salt: toBase64(salt),
    iv: toBase64(iv),
    encrypted: toBase64(encrypted),
    concatennated
  });
  return concatennated;
};

export const decode = async (string, tkey) => {
  const encrypted = fromBase64(string);
  const salt = encrypted.slice(0, salt_len);
  const iv = encrypted.slice(0 + salt_len, salt_len + iv_len);
  const key = await PBKDF2(tkey, salt);

  const decrypted = await window.crypto.subtle.decrypt(
    { name: "AES-CBC", iv },
    key,
    encrypted.slice(salt_len + iv_len)
  );
  const result = convertArrayBuffertoString(decrypted);
  console.log(result);
  return result;
};

